import React, { memo } from "react";
import { Box, Card, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import DoneIcon from "@mui/icons-material/Done";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import EstadoEntradaBadge from "../ui/EstadoEntradaBadge";
import { formatFechaHora } from "../../utils/formatters";

// Botón táctil (48px) que llama al callback con la entrada completa
const BotonAccion = ({ label, icon, onClick, entrada, disabled }) => (
    <IconButton
        aria-label={`${label} ${entrada.numero ?? ""}`.trim()}
        title={label}
        disabled={disabled}
        onClick={() => onClick(entrada)}
        sx={{ width: 48, height: 48 }}
    >
        {icon}
    </IconButton>
);

/**
 * Vista móvil de las entradas de la cola (tarjetas). Los callbacks reciben la
 * entrada completa, la misma firma que generateEntradaColumns.
 */
const EntradasMobileList = ({ entradas, loading, onLlamar, onFinalizar, onSaltar, procesandoId = null, bloqueado = false }) => {
    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                <CircularProgress sx={{ color: "#cc071e" }} />
            </Box>
        );
    }

    if (!entradas?.length) {
        return (
            <Typography variant="body2" sx={{ color: "#6c757d", textAlign: "center", py: 4 }}>
                No hay turnos en la cola
            </Typography>
        );
    }

    return (
        <Stack spacing={2}>
            {entradas.map((entrada) => {
                const deshabilitada = bloqueado || procesandoId === entrada.id;
                return (
                    <Card key={entrada.id} sx={{ p: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#212529" }}>
                                {entrada.numero}
                            </Typography>
                            <EstadoEntradaBadge estado={entrada.estado} size="small" />
                        </Box>
                        <Typography variant="caption" sx={{ color: "#6c757d", display: "block" }}>
                            Creado: {formatFechaHora(entrada.creado)}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#6c757d", display: "block" }}>
                            Modificado: {formatFechaHora(entrada.modificado)}
                        </Typography>
                        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 1 }}>
                            <BotonAccion label="Llamar" icon={<CampaignIcon />} onClick={onLlamar} entrada={entrada} disabled={deshabilitada} />
                            <BotonAccion label="Finalizar" icon={<DoneIcon />} onClick={onFinalizar} entrada={entrada} disabled={deshabilitada} />
                            <BotonAccion label="Saltar" icon={<SkipNextIcon />} onClick={onSaltar} entrada={entrada} disabled={deshabilitada} />
                        </Stack>
                    </Card>
                );
            })}
        </Stack>
    );
};

export default memo(EntradasMobileList);
